import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const TransferProgramDetailsWrapper = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;

  ${responsive.MOBILE`
    margin-top: 0px;
    margin-bottom: 16px;
  `}
  .transfer-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 24px;

    ${responsive.MOBILE`
      flex-direction: column;
      padding: 16px;
    `}
  }
  .transfer-box {
    flex: 1;
    background-color: ${COLORS.cirrus_black1};
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: 2px solid ${COLORS.cirrus_black1};

    ${responsive.MOBILE`
      width: 100%;
    `}
  }
  .source-program-label {
    line-height: 20px;
    color: ${COLORS.cirrus_black8};
    font-size: 20px;
    margin-top: 24px;
  }
  .source-program-container {
    margin-top: 24px;
  }
  .arrow-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
    width: 40px;
    height: 40px;
    background-color: ${COLORS.cirrus_green_light};
    color: ${COLORS.cirrus_green1};

    ${responsive.MOBILE`
      transform: rotate(90deg);
    `}
  }

  .source-delivery-office {
    height: 43px;
    h3,
    h4 {
      display: none;
    }
  }
`;
